import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'
import { getToken } from '@/utils/auth'
import router from '@/router'
import { serverUrl } from './ServerUrl'
import {tokenRemove} from "@/api/request/auth";
import StorageUtil from "@/utils/StorageUtil";

//通过实例化useRouter的router对象中，含有多个属性，其中就包含了当前路由地址，



let service = axios.create({
  headers: {
    'Cache-Control': 'no-cache'
  }
})

service.defaults.baseURL = serverUrl.mpServer

service.interceptors.request.use(config => {
  if(config.requestExternalAuth) {
    config.baseURL = serverUrl.externalAuthServer;
  }
  // 是否需要设置 token
  if (getToken() != null) {
    config.headers['Authorization'] = 'Bearer  ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }else {
    // cookie中取不到从 session中取
    let token = StorageUtil.select("Admin-Token",null);
    if (token != null) {
      config.headers['Authorization'] = 'Bearer  ' + token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
  }


  return config
}, function(error) {
  return Promise.reject(error)
})

export function get(url, params) {
  let paramsIn = qs.stringify(params, { allowDots: true, encode: true })
  if (url.indexOf('?') >= 0) {
    url = url + '&' + paramsIn
  }else {
    url = url + '?' + paramsIn
  }
  return new Promise((resolve, reject) => {
    service.get(url,{}).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        Modal.confirm(
          {
            content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
            title: '系统提示',
            okText: '重新登录',
            cancelText: '取消',
            onOk: () => {
              tokenRemove()
              window.location.href = window.applicationConfig.platformUrl;
            },
            onCancel: () => {
              Message.error(res.data.msg)
              reject(res.data.msg)
            }
          }
        )
      } else {
        Message.error(res.data.msg)
        reject(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}

export function  getExternal(url, params) {
  return new Promise((resolve, reject) => {
    service.get(url, { params: params, requestExternalAuth: true}).then( async res => {
      if (res.data) {
        resolve(res.data)
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, qs.stringify(params, { indices: false }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        Modal.confirm(
          {
            content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
            title: '系统提示',
            okText: '重新登录',
            cancelText: '取消',
            onOk: () => {
              tokenRemove()
              window.location.href = window.applicationConfig.platformUrl;
            },
            onCancel: () => {
              Message.error(res.data.msg)
              reject(res.data.msg)
            }
          }
        )
      } else {
        Message.error(res.data.msg)
        reject(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}

export function postFormData(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        Modal.confirm(
          {
            content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
            title: '系统提示',
            okText: '重新登录',
            cancelText: '取消',
            onOk: () => {
              tokenRemove()
              window.location.href = window.applicationConfig.platformUrl;
            },
            onCancel: () => {
              Message.error(res.data.msg)
              reject(res.data.msg)
            }
          }
        )
      } else {
        Message.error(res.data.msg)
        reject(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}

export function postJson(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, params).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        Modal.confirm(
          {
            content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
            title: '系统提示',
            okText: '重新登录',
            cancelText: '取消',
            onOk: () => {
              tokenRemove()
              window.location.href = window.applicationConfig.platformUrl;
            },
            onCancel: () => {
              Message.error(res.data.msg)
              reject(res.data.msg)
            }
          }
        )
      } else {
        Message.error(res.data.msg)
        reject(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    service.put(url, params).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        Modal.confirm(
          {
            content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
            title: '系统提示',
            okText: '重新登录',
            cancelText: '取消',
            onOk: () => {
              tokenRemove()
              window.location.href = window.applicationConfig.platformUrl;
            },
            onCancel: () => {
              Message.error(res.data.msg)
              reject(res.data.msg)
            }
          }
        )
      } else {
        Message.error(res.data.msg)
        reject(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}

export function deleteMethod(url, params) {
  return new Promise((resolve, reject) => {
    service.delete(url, params).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        Modal.confirm(
          {
            content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
            title: '系统提示',
            okText: '重新登录',
            cancelText: '取消',
            onOk: () => {
                let outer = window.applicationConfig.login.outer;
                let loginUrl = window.applicationConfig.login.url;
                let loginParams = window.applicationConfig.login.params;
                let host = window.applicationConfig.login.host;
                loginParams.redirect = host + router.currentRoute.fullPath
                if (outer === 1) {
                    window.open(loginUrl+'?'+qs.stringify(loginParams),'_self')
                }else {
                    router.push({ name: loginUrl })
                }
            },
            onCancel: () => {
              Message.error(res.data.msg)
              reject(res.data.msg)
            }
          }
        )
      } else {
        Message.error(res.data.msg)
        reject(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}

export function download(url) {
    return new Promise((resolve, reject) => {
        service.post(url, {
            responseType: "blob",
        }).then(res => {
            resolve(res)
        }).catch(err => {
            console.log(err)
            Message.error('服务器异常')
            reject('服务器异常')
        })
    })
}

export function clickDownload(response,name) {
    let blob = new Blob([response.data]);
    let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
    let a = document.createElement("a");
    a.href = url;
    a.download = name
    a.click();
    // 释放这个临时的对象url
    window.URL.revokeObjectURL(url);
}

/**
 * 文件上传（FormData）
 */
export function uploadFile(url, formData) {
  return new Promise((resolve, reject) => {
    service.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else if (res.data.code === 401) {
        Modal.confirm({
          content: '登录状态已过期，您可以继续留在该页面，或者重新登录',
          title: '系统提示',
          okText: '重新登录',
          cancelText: '取消',
          onOk: () => {
            tokenRemove()
            window.location.href = window.applicationConfig.platformUrl;
          },
          onCancel: () => {
            Message.error(res.data.msg)
            reject(res.data.msg)
          }
        })
      } else {
        Message.error(res.data.msg || '请求失败')
        reject(res.data.msg || '请求失败')
      }
    }).catch(err => {
      console.log(err)
      Message.error('服务器异常')
      reject('服务器异常')
    })
  })
}
